module.exports = __webpack_public_path__ + "img/brand-pic2-05.c48e1c82.png";